import React from 'react';
import { Form } from 'antd';
import { FormInstance } from 'antd/lib/form';
import { FieldData } from 'rc-field-form/lib/interface';
import { preventDefaultForEnterKey } from 'utils/helpers';

interface IProps {
	children: React.ReactNode;
	form: FormInstance;
	testId: string;
	onFinish: () => void;
	onFinishFailed?: () => void;
	onFieldsChange?: (changedFields: FieldData[], allFields: FieldData[]) => void;
}

export const FormPage: React.FC<IProps> = ({ children, form, testId, onFinish, onFinishFailed, onFieldsChange }) => (
	<Form
		className="p-4 flex flex-col gap-8"
		form={form}
		layout="vertical"
		data-test={testId}
		onFinish={onFinish}
		onFinishFailed={onFinishFailed}
		onFieldsChange={onFieldsChange}
		onKeyPress={preventDefaultForEnterKey}>
		{children}
	</Form>
);
